// pages/Contact.js
import React, { useState } from "react";
import {
  Box, Container, Typography, Grid,
  TextField, Button, Card, CardContent,
  Snackbar, Alert,
} from "@mui/material";
import EmailIcon    from "@mui/icons-material/Email";
import PhoneIcon    from "@mui/icons-material/Phone";
import LocationOnIcon from "@mui/icons-material/LocationOn";

const Contact = () => {
  const [formData, setFormData] = useState({ name: "", email: "", subject: "", message: "" });
  const [open, setOpen] = useState(false);

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    setOpen(true);
    setFormData({ name: "", email: "", subject: "", message: "" });
  };

  const contactInfo = [
    { icon: <EmailIcon sx={{ fontSize: 40 }} />,      title: "Email",    details: "hr@quantumitai.com" },
    { icon: <PhoneIcon sx={{ fontSize: 40 }} />,      title: "Phone",    details: "+1 (945) 278-6092" },
    { icon: <LocationOnIcon sx={{ fontSize: 40 }} />, title: "Location", details: "3400 Silverstone Dr, Ste. 134, Plano, TX 75023" },
  ];

  return (
    <Box>
      {/* ── Hero ── */}
      <Box
        sx={{
          background: "linear-gradient(135deg, #0D47A1 0%, #1565C0 50%, #1976D2 100%)",
          py: 12, mt: 8,
        }}
      >
        <Container maxWidth="lg">
          <Typography variant="h2" align="center" sx={{ color: "white", fontWeight: 700, mb: 2 }}>
            Contact Us
          </Typography>
          <Typography variant="h6" align="center" sx={{ color: "rgba(255,255,255,0.9)" }}>
            Let's discuss how we can help transform your business
          </Typography>
        </Container>
      </Box>

      {/* ── Contact Info + Form ── */}
      <Container maxWidth="lg" sx={{ py: 8 }}>
        <Grid container spacing={6}>
          {/* Contact Info Cards */}
          <Grid item xs={12} md={5}>
            <Typography variant="h5" sx={{ mb: 3, fontWeight: 600, color: "#0A1929" }}>
              Get in Touch
            </Typography>
            <Grid container spacing={3}>
              {contactInfo.map((info, index) => (
                <Grid item xs={12} sm={4} key={index}>
                  <Card
                    sx={{
                      borderRadius: 3,
                      boxShadow: "0 2px 12px rgba(13,71,161,0.08)",
                      border: "1px solid #E3F2FD",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        transform: "translateY(-6px)",
                        boxShadow: "0 8px 32px rgba(13,71,161,0.15)",
                        border: "1px solid #BBDEFB",
                      },
                    }}
                  >
                    <CardContent sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                      <Box sx={{ color: "#1565C0", flexShrink: 0 }}>{info.icon}</Box>
                      <Box>
                        <Typography variant="h6" sx={{ fontWeight: 600, color: "#0A1929" }}>
                          {info.title}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          {info.details}
                        </Typography>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Grid>

          {/* Contact Form */}
          <Grid item xs={12} md={7}>
            <Typography variant="h5" sx={{ mb: 3, fontWeight: 600, color: "#0A1929" }}>
              Send Us a Message
            </Typography>
            <Box component="form" onSubmit={handleSubmit} sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth label="Your Name" name="name"
                    value={formData.name} onChange={handleChange} required
                    sx={{ "& .MuiOutlinedInput-root": { "&.Mui-focused fieldset": { borderColor: "#1565C0" } } }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth label="Email Address" name="email" type="email"
                    value={formData.email} onChange={handleChange} required
                    sx={{ "& .MuiOutlinedInput-root": { "&.Mui-focused fieldset": { borderColor: "#1565C0" } } }}
                  />
                </Grid>
              </Grid>
              <TextField
                fullWidth label="Subject" name="subject"
                value={formData.subject} onChange={handleChange} required
                sx={{ "& .MuiOutlinedInput-root": { "&.Mui-focused fieldset": { borderColor: "#1565C0" } } }}
              />
              <TextField
                fullWidth label="Message" name="message" multiline rows={5}
                value={formData.message} onChange={handleChange} required
                sx={{ "& .MuiOutlinedInput-root": { "&.Mui-focused fieldset": { borderColor: "#1565C0" } } }}
              />
              <Button
                type="submit" variant="contained" size="large"
                sx={{
                  bgcolor: "#1565C0", color: "white",
                  px: 5, py: 1.8, fontSize: "1rem", fontWeight: 700,
                  borderRadius: 2,
                  alignSelf: "flex-start",
                  boxShadow: "0 4px 16px rgba(13,71,161,0.3)",
                  "&:hover": { bgcolor: "#0D47A1", transform: "translateY(-2px)", boxShadow: "0 8px 24px rgba(13,71,161,0.4)" },
                }}
              >
                Send Message
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Container>

      <Snackbar open={open} autoHideDuration={6000} onClose={() => setOpen(false)}>
        <Alert severity="success" sx={{ width: "100%", bgcolor: "#E3F2FD", color: "#0D47A1" }}>
          Message sent successfully! We'll get back to you soon.
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default Contact;
